import axios from "axios"

const paramsSerializer = (params) => {
  const Qs = require("qs")
  return Qs.stringify(params, { encode: false })
}

export const findOrganizations = (headers, params) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations`,
    {
      headers,
      params,
      paramsSerializer
    }
  )
}

export const findOrganizationsByCurrentId = (headers, params) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/find-by-current-user-id`,
    {
      headers,
      params,
      paramsSerializer
    }
  )
}

export const findOrganizationById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${id}`,
    {
      headers
    },
    { useCache: false }
  )
}

export const createOrganization = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations`,
    data,
    {
      headers
    }
  )
}

export const updateOrganization = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${id}`,
    data,
    {
      headers
    }
  )
}

export const uploadLogo = (headers, id, formData) => {
  return axios.put(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${id}/logo`,
    formData,
    {
      headers
    }
  )
}

export const deleteOrganization = (headers, id) => {
  return axios.delete(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${id}`,
    {
      headers
    }
  )
}

export const deleteOrganizations = (headers, ids) => {
  return axios.delete(
    `${process.env.REACT_APP_MANAGEMENT_API_URL
    }/organizations?id=${ids.join()}`,
    {
      headers
    }
  )
}

export const lockOrganization = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/lock-or-unlock-organization/${id}`,
    data,
    {
      headers
    }
  )
}

export const traCuuMaSoThue = (headers, code) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${code}/find`,
    {
      headers
    }
  )
}

export const addMemberCustomer = (headers, id, data) => {
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${id}/add-member-customer`,
    data,
    {
      headers
    }
  )
}

export const editMemberCustomer = (headers, idOrg, idMember, data) => {
  return axios.patch(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${idOrg}/customers/${idMember}`,
    data,
    {
      headers
    }
  )
}

export const addMemberCustomerIframe = (headers, id, appId, messageId, data) => {
  return axios.put(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/integrated/organization/${id}/add-member-to-org-iframe/${appId}/${messageId}`,
    data,
    {
      headers
    },
    { useCache: false }
  )
}

export const importMembers = (headers, id, formData) => {
  headers["Content-Type"] = "multipart/form-data"
  return axios.post(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${id}/import`,
    formData,
    {
      headers
    }
  )
}

export const findClientsById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_MANAGEMENT_API_URL}/organizations/${id}/find-clients`,
    {
      headers
    },
    { useCache: false }
  )
}

